var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-icon',_vm._b({},'v-icon',Object.assign({}, _vm.attrs,
        ( _obj = {}, _obj[_vm.attrs.size] = true, _obj )),false),[_vm._v(" "+_vm._s(_vm.attrs.icon || 'mdi-plus')+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }